import { render, staticRenderFns } from "./CFDReport.vue?vue&type=template&id=19968d36&"
import script from "./CFDReport.vue?vue&type=script&lang=js&"
export * from "./CFDReport.vue?vue&type=script&lang=js&"
import style0 from "./CFDReport.vue?vue&type=style&index=0&id=19968d36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports